export const enum StorageTarget {
    MEMBER = 'Member',
    PROCESSOR = 'Processor'
}